export class TransferenciaBeneficio {

    public cedenteGuid: string;
    public contaOrigemGuid: string;
    public contaDestinoGuid: string;
    public valor: number;
    public dataResgate: Date;
    public gestorResponsavelResgateGuid: string;

    constructor() { }
}
